import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { KioskActions, KioskActionTypes } from './kiosk.actions';
import { Kiosk } from './kiosk.model';

export interface State extends EntityState<Kiosk> {
  // additional entities state properties
}

export const adapter: EntityAdapter<Kiosk> = createEntityAdapter<Kiosk>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export function reducer(state = initialState, action: KioskActions): State {
  switch (action.type) {
    case KioskActionTypes.AddKiosk: {
      return adapter.addOne(action.payload.kiosk, state);
    }

    case KioskActionTypes.UpsertKiosk: {
      return adapter.upsertOne(action.payload.kiosk, state);
    }

    case KioskActionTypes.AddKiosks: {
      return adapter.addMany(action.payload.kiosks, state);
    }

    case KioskActionTypes.UpsertKiosks: {
      return adapter.upsertMany(action.payload.kiosks, state);
    }

    case KioskActionTypes.UpdateKiosk: {
      return adapter.updateOne(action.payload.kiosk, state);
    }

    case KioskActionTypes.UpdateKiosks: {
      return adapter.updateMany(action.payload.kiosks, state);
    }

    case KioskActionTypes.DeleteKiosk: {
      return adapter.removeOne(action.payload.id, state);
    }

    case KioskActionTypes.DeleteKiosks: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case KioskActionTypes.LoadKiosks: {
      return adapter.setAll(action.payload.kiosks, state);
    }

    case KioskActionTypes.ClearKiosks: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
